import React from 'react';
import { Avatar } from '@chakra-ui/react';
import { ff } from '../../../theme';

type Props = {
  name: string;
  logoUrl?: string;
  size?: number;
  /** Corner radius in px (board: 14 on board/My Bounties, 12 on claim + submitted summaries). */
  radius?: number;
  /** Initials font size in px. */
  fontSize?: number;
};

/** Rounded-square brand logo; falls back to initials on a grey tile. */
const BrandTile: React.FC<Props> = ({ name, logoUrl, size = 52, radius = 14, fontSize = 15 }) => (
  <Avatar
    src={logoUrl}
    name={name}
    w={`${size}px`}
    h={`${size}px`}
    flex="none"
    borderRadius={`${radius}px`}
    bg={ff.grey}
    color={ff.ink}
    fontWeight={600}
    sx={{ '& img': { borderRadius: `${radius}px` }, '& > div': { fontSize: `${fontSize}px` } }}
  />
);

export default BrandTile;
